import React from "react";

const AlertCircleFilledIcon = (props) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47656 0.164062C3.55 0.164062 0.367188 3.34688 0.367188 7.27344C0.367188 11.2 3.55 14.3828 7.47656 14.3828C11.4031 14.3828 14.5859 11.2 14.5859 7.27344C14.5859 3.34688 11.4031 0.164062 7.47656 0.164062ZM7.47656 11.3066C7.0232 11.3066 6.65625 10.9391 6.65625 10.4863C6.65625 10.0335 7.0232 9.66602 7.47656 9.66602C7.92938 9.66602 8.29688 10.0335 8.29688 10.4863C8.29688 10.9391 7.92938 11.3066 7.47656 11.3066ZM8.29688 7.75195C8.29688 8.20477 7.92938 8.57227 7.47656 8.57227C7.0232 8.57227 6.65625 8.20477 6.65625 7.75195V3.92383C6.65625 3.47047 7.0232 3.10352 7.47656 3.10352C7.92938 3.10352 8.29688 3.47047 8.29688 3.92383V7.75195Z"
        fill="#AD7F00"
      />
    </svg>
  );
};

export default AlertCircleFilledIcon;
